import React from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { ValueProposition } from "../components/ValueProposition";
import { Collections } from "../components/Collections";
import { BrandStory } from "../components/BrandStory";
import { Footer } from "../components/Footer";
import { Toaster } from "../components/ui/sonner";

export const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <ValueProposition />
      <Collections />
      <BrandStory />
      <Footer />
      <Toaster />
    </div>
  );
};

export default HomePage;
